import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState } from "../../../store/store.interface";
import { ActionStatus } from "../../../common/constants/action-status";
import { getFetchWishlistsApiCallMagento } from "../apis/wish-list-my-account.api";
import { getAllWishlistUrlMagento } from "../utils/wish-list.util";

export const fetchAllWishLists = createAsyncThunk('wishList/getAllWishLists', async (_: undefined, thunkAPI) => {
  const state = thunkAPI.getState() as StoreState;

  const url = getAllWishlistUrlMagento(state);
  return await getFetchWishlistsApiCallMagento(url);
  }, {
  condition: ((_arg, { getState }) => {
    const state = getState() as StoreState;
    if (state.wishListState.myAccountWishLists.status == ActionStatus.loading) {
      return false;
    }
    return true;
  })
});